import {Component, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {ApplicantDetailsComponent} from '../../../shared/components/applicant-details/applicant-details.component';
import {LoginService} from '../../../shared/services/login.service';
import {Router} from '@angular/router';
import {UploadFileComponent} from '../../../shared/components/upload-file/upload-file.component';
import {UploadfilesViewmodel} from '../../../shared/viewmodels/uploadfiles-viewmodel';
import {Steps} from 'primeng/primeng';
import {IppaymentComponent} from '../../../shared/components/ippayment/ippayment.component';
import {IppaymentService} from '../../../shared/services/ippayment.service';
import {ApplicationFormBase} from '../../../shared/data-objects/application-form-base';
import * as MenuUtils from '../../../shared/data-objects/menu-item-ex';
import {ServiceBase} from '../../../shared/services/service-base';
import {Hyd} from '../hyd';
import {WorkrequestHydComponent} from '../workrequest-hyd/workrequest-hyd.component';
import {WorkrequestHydViewmodel} from '../workrequest-hyd-viewmodel';
import {HydService} from '../hyd.service';
import {Meta} from '@angular/platform-browser';
import {LocationDetails} from '../../../shared/data-objects/location-details';
import {AddressService} from '../../../shared/services/address.service';
import {environment} from '../../../../app-environments/environment';

Steps.prototype.itemClick = MenuUtils.itemClick;

@Component({
  selector: 'app-hyd',
  templateUrl: 'hyd.component.html',
  styleUrls: ['hyd.component.css'],
  entryComponents: [ApplicantDetailsComponent, WorkrequestHydComponent,
    UploadFileComponent, IppaymentComponent],
  encapsulation: ViewEncapsulation.None
})

export class HydComponent extends ApplicationFormBase<Hyd> implements OnInit {
  imageSourceUrl = ServiceBase.baseHref + '/assets/images/pfi.png';
  locationAddress = '1 MCNAB AVENUE, FOOTSCRAY';

  @ViewChild('WorkrequestComponent') workrequestComponent: WorkrequestHydComponent;
  @ViewChild('UploadFileComponent') uploadFileComponent: UploadFileComponent;

  constructor(protected loginService: LoginService, private hydService: HydService, protected ipPaymentService: 
              IppaymentService, protected router: Router, private meta: Meta, private addressService: AddressService) {
    super(hydService, loginService, ipPaymentService, router);
    this.meta.updateTag({ name: 'description', content: 'Request permission to access water from a hydrant/fire plug.' });
  }

  async ngOnInit() {
    super.ngOnInit();

    let isTokenValid = await this.loginService.isTokenValid();
    if(!isTokenValid) {
      if(this.loginService.isGuestUserLoggedIn()) {
        this.loginService.guestLogin((ok: boolean)=>{
          this.setupTotalOrderAmount();
          this.setupTabs();
        });
      } else {
        this.router.navigate(['/login']);
      }
    } else {
      await this.loginService.refreshToken();
      this.setupTotalOrderAmount();
      this.setupTabs();
    }

    this.locationAddress = await this.getLocationAddress();
  }

  async getLocationAddress() : Promise<string> {
    try {
      let installNum = environment.cwwInstallationNumber;
      let locDetails : any = await this.addressService.validateInstallationNumber(installNum, this.loginService.getToken()).toPromise();
      return locDetails && locDetails.LocationAddress ? locDetails.LocationAddress : '1 MCNAB AVENUE, FOOTSCRAY';
    } catch (e) {
      return '1 MCNAB AVENUE, FOOTSCRAY';
    }
  }

  setupTotalOrderAmount(): void {
    this.ipPaymentService.paymentformIsInit.subscribe((data: any) => {
      this.paymentformIsInit(4, this.workrequestComponent.totalOrderAmount);
    });
  }

  setupTabs(): void {
    const me = this;

    // if (!this.loginService.isGuestUserLoggedIn()) {
    if (this.loginService.isUserBillLater()) {
      this.setApplicantDetailsForBillLater(this.applicationService.applicationData.applicant);
    } else {
      // this.setApplicantDetailsForGuestUser(this.applicationService.applicationData.applicant);
      this.setApplicantDetailsForNonBillLater(this.applicationService.applicationData.applicant);
    }
    // if (!this.loginService.isGuestUserLoggedIn()) {
    if (this.loginService.isUserBillLater()) {
      this.addMenuItem('Work request', me, 0, 'First Step');
      this.addMenuItem('Upload files', me, 1, 'Second Step');
      this.addMenuItem('Applicant details', me, 2, 'Third Step');
      this.addMenuItem('Review and submit', me, 3, 'Fourth Step');
    } else {
      this.addMenuItem('Work request', me, 0, 'First Step');
      this.addMenuItem('Upload files', me, 1, 'Second Step');
      this.addMenuItem('Applicant details', me, 2, 'Third Step');
      this.addMenuItem('Review and submit', me, 3, 'Fourth Step');
      this.addMenuItem('Payment', me, 4, 'Fifth Step');
    }
  }

  onFeeCodesReceived(): void {
  }

  getTotalOrderAmount(): number {
    return this.workrequestComponent.totalOrderAmount;
  }

  get controlLabel(): string {
    return 'Upload file';
  }

  get workRequestViewModel(): WorkrequestHydViewmodel {
    return this.hydService.workRequestViewModel;
  }

  get uploadfilesViewmodel(): UploadfilesViewmodel {
    return this.hydService.uploadfilesViewmodel;
  }

  get userQuestionnaireAttached(): boolean {
    return this.hydService.userQuestionnaireAttached;
  }

  set userQuestionnaireAttached(v: boolean) {
    this.hydService.userQuestionnaireAttached = v;
  }

  get backflowTestResultsAttached(): boolean {
    return this.hydService.backflowTestResultsAttached;
  }

  set backflowTestResultsAttached(v: boolean) {
    this.hydService.backflowTestResultsAttached = v;
  }

  get agreedToHydConditions(): boolean {
    return this.hydService.agreedToHydConditions;
  }

  set agreedToHydConditions(v: boolean) {
    this.hydService.agreedToHydConditions = v;
  }

  canGoNext(executeYes: any, executeNo: any): void {
    this.hydService.submitErrorMessage = '';

    if (this.activeIndex === 0) {
      this.workrequestComponent.errorMessage = null;
      if (this.workrequestComponent.displayErrorMessage().length > 0) {
        this.workrequestComponent.displayErrorMessage();
        executeNo();
      } else {
        executeYes();
      }
    } else if (this.activeIndex === 1) {
      if (!this.uploadFileComponent.isValid) {
        executeNo();
      } else if (!this.userQuestionnaireAttached) {
        this.hydService.submitErrorMessage += 'Please confirm user questionnaire is attached.';
        executeNo();
      } else if (!this.backflowTestResultsAttached) {
        this.hydService.submitErrorMessage += 'Please confirm backflow test results are attached.';
        executeNo();
      } else {
        executeYes();
      }
    } else if (this.activeIndex === 2) {
      if (this.applicant.invalid && this.applicant.displayErrorMessage().length > 0) {
        this.hydService.submitErrorMessage += this.applicant.displayErrorMessage();
        executeNo();
        return;
      }

      if (!this.hydService.agreedToHydConditions) {
        this.hydService.submitErrorMessage += 'Please select Hydrant Permit and Agreement Terms and Conditions.';
        executeNo();
        return;
      }

      this.validTermsAndConditions(executeNo, executeYes);
    // } else if (this.isGuestUserLoggedIn && this.activeIndex === 3) {
    } else if (!this.loginService.isUserBillLater() && this.activeIndex === 3) {
      // this.navigateToPaymentWhenGuestUser(executeYes, executeNo, this.workrequestComponent.totalOrderAmount, this.submitApplication.bind(this));
      this.navigateToPaymentWhenNonBillLaterUser(executeYes, executeNo, this.workrequestComponent.totalOrderAmount, this.submitApplication.bind(this));
    } else {
      executeYes();
    }
  }

  goNext(): void {
    // if ((!this.isGuestUserLoggedIn && this.activeIndex === 3) || (this.isGuestUserLoggedIn && this.activeIndex === 4)) {
    if ((this.loginService.isUserBillLater() && this.activeIndex === 3) || (!this.loginService.isUserBillLater() && this.activeIndex === 4)) {
      return;
    }

    this.canGoNext(() => {
      this.activeIndex++;
    }, () => {
    });
  }

  canGoPrevious(): boolean {
    // if (this.isGuestUserLoggedIn && (this.activeIndex === 4 || this.activeIndex === 0)) {
    if (!this.loginService.isUserBillLater() && (this.activeIndex === 4 || this.activeIndex === 0)) {
      return false;
    }

    // if (!this.isGuestUserLoggedIn && this.activeIndex === 0) {
    if (this.loginService.isUserBillLater() && this.activeIndex === 0) {
      return false;
    }

    return true;
  }

  goPrevious(): void {
    if (!this.canGoPrevious()) {
      return;
    }

    this.activeIndex--;
  }

  submitApplication(callback): void {

    let validData = true;
    this.hydService.submitErrorMessage = '';

    this.workrequestComponent.errorMessage = null;
    if (this.workrequestComponent.displayErrorMessage().length > 0) {
      this.hydService.submitErrorMessage += this.workrequestComponent.displayErrorMessage();
      validData = false;
    }

    if (!this.uploadFileComponent.isValid) {
      this.hydService.submitErrorMessage += this.uploadFileComponent.submitErrorMessage;
      validData = false;
    }

    if (this.applicant.displayErrorMessage().length > 0) {
      this.hydService.submitErrorMessage += this.applicant.displayErrorMessage();
      validData = false;
    }

    if (!this.hydService.agreedToTsAndCs) {
      this.hydService.submitErrorMessage += 'Please select terms and conditions.';
      validData = false;
    }

    if (!validData) {
      return;
    }
    this.setApplicantData();
    this.hydService.applicationData.toUpperCase();
    this.hydService.applicationData.workrequestDetails = this.workrequestComponent.workRequestViewModel.workrequestDetails;
    this.hydService.applicationData.workrequestDetails.setDescriptionOfWork();
    this.hydService.applicationData.locationAddress = this.locationAddress;
    this.doSubmit(callback);
  }

  newApplication(): void {
    window.location.reload();
    // super.newApplication();
    // this.hydService.agreedToTsAndCs = true;
    // this.uploadFileComponent.clearFiles();
    // this.workrequestComponent.markValidationControlsAsUntouched();
  }

  get shouldDisplayWorkRequest(): boolean {
    return this.activeIndex === 0;
  }

  get shouldDisplayUploadFiles(): boolean {
    return this.activeIndex === 1;
  }

  get shouldDisplayApplicant(): boolean {
    return this.activeIndex === 2;
  }

  get shouldShowSubmitAndReview(): boolean {
    return this.activeIndex === 3;
  }

  get shouldDisplayPaymentForm(): boolean {
    // return this.isGuestUserLoggedIn && this.activeIndex === 4;
    return !this.loginService.isUserBillLater() && this.activeIndex === 4;
  }

  get shouldDisplayNextButton(): boolean {
    return this.activeIndex < 3;
  }

  get propertyDescription(): string {
    return this.location.addressDetails.locationAddress;
  }

  get onPS(): string {
    return this.location.addressDetails.propertyServiceNo;
  }

  private doSubmit(callback): void {
    this.executeSubmit('hyd', callback, this.workrequestComponent.totalOrderAmount, this.uploadFileComponent, true);
  }
}



// WEBPACK FOOTER //
// ./src/app/create-application/hyd-form/hyd/hyd.component.ts